import EditableCardEntryInput from "../editable_entries/EditableCardEntryInput";
import EditableCardEntryUser from "../editable_entries/EditableCardEntryUser";


const EmployeeFilter = ({filter, onEdit, showManager = false}) => {
    return <>
        <EditableCardEntryInput
            displayLabel={"Employee Name"}
            onEdit={(v) => onEdit({name: v})}
            baseValue={filter.name}
            isEditing={true}
            type={"text"}
        />
        <EditableCardEntryInput
            displayLabel={"Employee ID"}
            onEdit={(v) => onEdit({pcid: Number(v)})}
            baseValue={filter.pcid}
            isEditing={true}
            type={"number"}
        />
        {showManager ? <EditableCardEntryUser
            isEditing={true}
            baseValue={filter.managerID}
            onEdit={(v) => onEdit({managerID: Number(v)})}
            displayLabel={"Manager"}
            filterFunction={(e) => e.coOwn}
            showPCID={true}
        /> : null}
    </>;
}

export default EmployeeFilter;